<template>
  <div class="unit-mgmt">
    <div class="main-title">
      <p>组织管理</p>
    </div>
    <div class="main-body">
      <table class="table-custom">
        <thead>
        <tr>
          <th>组织编号</th>
          <th>组织名称</th>
          <th>组织地址</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList">
          <td>{{ item.unitNo }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.location }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onManageBtnClick(item)">管理该组织</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="4">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'unitMgmt',
  data() {
    return {
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
    }
  },
  mounted() {
    this.queryUserAccount();
  },
  methods: {
    queryUserAccount() {
      this.$http.post('/managementPlatform/unit/getBelongUnit').then(response => {
        let res = response.data;
        if (!res || !res.result) {
          this.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        this.dataList = res.mdata && res.mdata.unitList;
      }).catch(err => {
        console.log(err);
      });
    },
    onManageBtnClick(item) {
      this.$router.push('/managePage/unitMgmtManageView?' + this.$qs.stringify(item));
    },
  },
}
</script>

<style lang="scss" scoped>
.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/unitMgmt.vue